// ----------------------------------------------------------------------------
// Component: Carousel
// ----------------------------------------------------------------------------
import $ from 'jquery';
// Style includes
import '../sections/slick-carousel-custom';
import 'slick-carousel/slick/slick.scss';

const arrowLeft  = '<button type="button" class="slick-prev"><div class="icon--stroke"><svg class="icon icon__carousel-arrow--left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-carousel-arrow--left"></use></svg></div><span class="sr-only">Previous</span></button>';
const arrowRight = '<button type="button" class="slick-next"><div class="icon--stroke"><svg class="icon icon__carousel-arrow--right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-carousel-arrow--right"></use></svg></div><span class="sr-only">Next</span></button>';


$('.carousel--product').slick({
    infinite: false,
    dots: false,
    nextArrow:      arrowRight,
    prevArrow:      arrowLeft,
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 0,
    accessibility: false,
    asNavFor: '.carousel--product-thumbnails'
});

$('.carousel--product-thumbnails').slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    rows: 1,
    accessibility: false,
    asNavFor: '.carousel--product',
    arrows: false,
    dots: false,
    focusOnSelect: true,
    useCSS: false,
    useTransform: false
});


$(function() {
    $('.swatch :radio').change(function() {
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();
        $(this)
          .closest('form')
          .find('.single-option-selector')
          .eq(optionIndex)
          .val(optionValue)
          .trigger('change');
    });
});
